import { ClientSecret } from "api/account/client";
import { SvgIconName } from "components/components/Icon/Icon";
import LineTable from "components/components/LineTable/LineTable";
import React from "react";
import { DateFormat, formatDateTimeString } from "utils/dateHelpers";

import SecretStatus from "./SecretStatus";
import { DeleteSecretButton, SecretsActionCell } from "./style";

type Props = {
  applicationSecrets: ClientSecret[];
  deleteDisabled: boolean;
  setSecretToDelete: (s: ClientSecret) => void;
  expiredTooltipText: string;
  expiringSoonTooltipText: string;
};

const SecretsTable: React.FC<Props> = ({
  applicationSecrets,
  deleteDisabled,
  setSecretToDelete,
  expiredTooltipText,
  expiringSoonTooltipText,
}) => {
  const headers: React.ReactNode[] = [
    "Secret Hint",
    "Expiry date",
    "Status",
    "Action",
  ];

  return (
    <LineTable
      ariaLive="polite"
      items={applicationSecrets}
      headers={headers}
      getRowValues={(s): React.ReactNode[] => [
        <>{s.secretHint.padEnd(18, "*")}</>,
        <>
          {formatDateTimeString(new Date(s.expiryTime), DateFormat.DateOnly)}
        </>,
        <SecretStatus
          key="status"
          expiryTime={s.expiryTime}
          expiredTooltipText={expiredTooltipText}
          expiringSoonTooltipText={expiringSoonTooltipText}
        />,
        <SecretsActionCell key="action">
          <DeleteSecretButton
            ariaLabel="delete"
            buttonText="Delete"
            iconName={SvgIconName.Delete}
            onClick={(): void => setSecretToDelete(s)}
            disabled={deleteDisabled}
            textLeftOfIcon
          />
        </SecretsActionCell>,
      ]}
      emptyCell={<>—</>}
    />
  );
};

export default SecretsTable;
